import React from 'react';
import { SvgIcon } from '@mui/material';

export const NoAlarms = ({ width = 29, height = 48, color = '#989B9C' }) => {
  return (
    <SvgIcon viewBox="0 0 29 48" style={{ width: `${width}px`, height: `${height}px` }}>
      <path
        d="M4.5 21C3.95 21 3.47917 20.8042 3.0875 20.4125C2.69583 20.0208 2.5 19.55 2.5 19V14C2.5 13.45 2.69583 12.9792 3.0875 12.5875C3.47917 12.1958 3.95 12 4.5 12H9.5C9.5 12.8333 9.79167 13.5417 10.375 14.125C10.9583 14.7083 11.6667 15 12.5 15C13.3333 15 14.0417 14.7083 14.625 14.125C15.2083 13.5417 15.5 12.8333 15.5 12H20.5C21.05 12 21.5208 12.1958 21.9125 12.5875C22.3042 12.9792 22.5 13.45 22.5 14V19C22.5 19.55 22.3042 20.0208 21.9125 20.4125C21.5208 20.8042 21.05 21 20.5 21H4.5ZM4.5 19H20.5V14H17.1C16.6833 14.9167 16.0625 15.6458 15.2375 16.1875C14.4125 16.7292 13.5 17 12.5 17C11.5 17 10.5875 16.7292 9.7625 16.1875C8.9375 15.6458 8.31667 14.9167 7.9 14H4.5V19ZM18.1 10.8L16.7 9.4L20.25 5.85L21.65 7.25L18.1 10.8ZM6.9 10.8L3.35 7.25L4.75 5.85L8.3 9.4L6.9 10.8ZM11.5 8V3H13.5V8H11.5Z"
        fill={color}
      />
    </SvgIcon>
  );
};
